import React, { useEffect, useState } from "react";
import "./Login.css";
import loginImage from "../../assets/images/back1234.png";
import vectorImage from "../../assets/images/Logo.png";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { env } from "../../environment.js";
import genAI from '../../assets/images/UPL_Genie_logo 1.svg'
import PoweredBy from '../../assets/images/PoweredBy.svg'
// PoweredBy.svg

function Login() { 
  const [loginState, setLoginState] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    checkAndLoginUser();
  }, [location.search]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     fetchAuthenticatedAPI();
  //   }, 5000);
  //   return () => clearTimeout(timer);
  // }, []);
  
  const checkAndLoginUser = () => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
    if (code) {
      setLoginState(false);
      fetchUserTokenAndAuthenticate(code);
    }
  };

  const fetchUserTokenAndAuthenticate = async (code) => {
    // setLoginState(false);
    try {
      const response = await axios.post(`${env.baseURL}/auth/azure/authenticate`, {
         code: code
      });
      let item = response.data;
      localStorage.setItem("token", item.token);
      localStorage.setItem("LoggedInDetails", JSON.stringify(item.app_user));
      localStorage.setItem("isLogin", true);
      navigate("/dashboard");
      setLoginState(true);
      toast.success("You are successfully logged in");
    } catch (error) {
      setLoginState(true);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoginState(true);
    }
  };

  const fetchAuthenticatedAPI = () => {
    axios
      .get(`${env.baseURL}/auth/azure/auth-info`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        let data=response?.data;
        ssoSignIn(data);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const ssoSignIn = (props) => {
    const item = props;
    const loginUrl = item.login_url;
    const logOutUrl = item.logout_url;
    if (loginUrl) {
      localStorage.setItem("loginUrl", loginUrl);
      window.location.href = loginUrl;
    }
    if (logOutUrl) {
      localStorage.setItem("logOutUrl", logOutUrl);
    }
  };

  return (
    <>
      <ToastContainer closeButton={true} position="top-right" />
      {!loginState ? (
        <div
        className="loginWaitContainer"
          style={{
            // backgroundImage: `url(${loginImage})`,
            // backgroundSize: "cover",
            // backgroundPosition: "center",
            // height: "100%",
            // overflow: "hidden",
          }}
        >
          <div className="sidebar-profile-sub-title">
            Please wait a while...
          </div>
          {/* <div className="parentLoginContainer">
            <div className="parentTextContainer">
              <div className="textContainer">
                <div>
                  <img width={'100%'} height={"100%"} src={vectorImage} alt="vector" />
                </div>
                <div className="loginTo">
                  <span>Log in to continue</span>
                </div>
                <div className="loginButtonContainer">
                  <button
                    className="buttonAlignment"
                    onClick={fetchAuthenticatedAPI}
                  >
                    Log In
                  </button>
                </div>
              </div>
          <div className="copyright-label-login">
            © 2025AIChat. All Rights Reserved.
          </div>
            </div>
          </div> */}
        </div>
      ) : (
        <div className="loginWaitContainer">
          <div className="dashboard-profile-container">
                   <span>
                    <div className="sidebar-profile-sub-title">
                        Welcome to
                      </div>
                      <div>
                        <img
                          style={{ width: "100%", height: "100%" }}
                          src={genAI}
                          alt=""
                        />
                      </div>
                    </span>  
                      <div className="powered">
                        <img height='130%' width="130%" src={PoweredBy} alt="" />
                      </div>
                    </div>

        </div>
      )}
    </>
  );
}

export default Login;
